export let API_URL= 'https://portals-api.shivaami.com/'
// export let API_URL= 'http://localhost:8000/'
